import React from 'react';
import { motion } from 'framer-motion';
import { GiftIcon, LineChartIcon, SproutIcon, TagIcon, WalletIcon } from 'lucide-react';
import { outcomes } from '../data/content';
const icons = {
  Wallet: WalletIcon,
  Tag: TagIcon,
  Gift: GiftIcon,
  LineChart: LineChartIcon,
  Sprout: SproutIcon
};
export function Outcomes() {
  return <section className="w-full bg-forest py-16 sm:py-24" aria-labelledby="logros-title" data-id="element-110" data-mp="1r74guc15c23v">
      <div className="mx-auto max-w-6xl px-5" data-id="element-111" data-mp="ti2k0ofl7knj">
        <div className="mx-auto max-w-2xl text-center" data-id="element-112" data-mp="yigtmawu72no">
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-sage" data-id="element-113" data-mp="ygvwcdj515m4">
            Resultados
          </span>
          <h2 id="logros-title" className="mt-3 font-display text-3xl font-extrabold tracking-tight text-white sm:text-4xl" data-id="element-114" data-mp="188ryq0s9bhw5">
            Lo que vas a lograr con Negocio Rentable
          </h2>
        </div>

        <ul className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-115" data-mp="fr63vx2ukvxd">
          {outcomes.map((outcome, index) => {
          const Icon = icons[outcome.icon];
          return <motion.li key={outcome.title} initial={{
            opacity: 0,
            y: 18
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-60px'
          }} transition={{
            duration: 0.4,
            delay: index * 0.06
          }} className="rounded-2xl bg-white/95 p-6 shadow-card" data-id="element-116" data-mp="2xzpy8tbt8wmn" data-mpi={index}>
                <span className="inline-flex h-11 w-11 items-center justify-center rounded-xl bg-sage-light" data-id="element-117" data-mp="2f7dzegkd8dh9">
                  <Icon className="h-5 w-5 text-forest" aria-hidden="true" data-id="element-118" data-mp="2a82fwzsm6tvz" />
                </span>
                <h3 className="mt-5 font-display text-lg font-bold text-black" data-id="element-119" data-mp="2680nzicoletw">
                  {outcome.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-forest-deep/75" data-id="element-120" data-mp="8go9lcb378l9">
                  {outcome.description}
                </p>
              </motion.li>;
        })}
        </ul>
      </div>
    </section>;
}